import { useState, useEffect } from "react";
import SocialIcons from "./reusables/SocialIcons";
import BackToTop from "./reusables/BackToTop";

function Footer() {
	const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

	useEffect(() => {
		setCurrentYear(new Date().getFullYear());
	}, []);

	return (
		<footer className='px-10 p-5 lg:px-24 border-t-2 border-gray-900'>
			<div className='mx-auto max-w-7xl py-4 px-4 sm:px-6 md:flex md:items-center md:justify-between lg:px-2'>
				<div className='flex justify-center space-x-6 md:order-2'>
					<SocialIcons />
				</div>
				<div className='flex md:justify-end mt-8 md:order-1 md:mt-0'>
					<nav className='flex flex-wrap justify-center gap-8'>
						<a
							href='#Hero'
							className='text-base text-gray-900 hover:text-indigo-500'>
							About Me
						</a>
						<a
							href='#Services'
							className='text-base text-gray-900 hover:text-indigo-500'>
							Services
						</a>
						<a
							href='#Portfolio'
							className='text-base text-gray-900 hover:text-indigo-500'>
							Portfolio
						</a>
						<a
							href='#Testimonials'
							className='text-base text-gray-900 hover:text-indigo-500'>
							Testimonials
						</a>
						<a
							href='#Contact'
							className='text-base text-gray-900 hover:text-indigo-500'>
							Contact
						</a>
					</nav>
				</div>
				<div className='text-base text-gray-900 text-center'>
					© {currentYear} Martins Akhivbareme.
					<br className='md:hidden md:block' />
					<span> All rights reserved.</span>
				</div>
			</div>
			<BackToTop />
		</footer>
	);
}

export default Footer;
